import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { C } from 'src/app/@shared/constants';
import { LanguageService } from 'src/app/@core/language.service';

@Component({
  selector: 'proto-language-switch',
  standalone: false,
  styleUrls: ['./language-switch.component.scss'],
  templateUrl: './language-switch.component.html',
})
export class LanguageSwitchComponent {
  public availableLanguages: string[];
  public currentLanguage: string;

  private languageService = inject(LanguageService);
  private translate = inject(TranslateService);

  public ngOnInit(): void {
    this.availableLanguages = C.availableLanguages.map((language) => { return language.toUpperCase(); });
    this.currentLanguage = this.translate.currentLang.toUpperCase();
  }

  public changeLanguage(event: CustomEvent): void {
    const { currentLanguage } = this;

    this.languageService.changeLanguage(event.detail.value.toLowerCase()).catch((error) => {
      console.error(error);
      this.currentLanguage = currentLanguage;
    });
  }
}
